import { otherRouter, appRouter } from '@/router/router';
import { router } from '@/router/index';

const state = {
    prefix: '',
    routers: [
        otherRouter,
        ...appRouter
    ],
    menuList: [],
    tagsList: [...otherRouter.children],
    pageOpenedList: [],
    currentPageName: '',
    currentPath: [],
    openedSubmenuArr: [],
    menuTheme: '',
    theme: '',
    cachePage: [],
    lang: '',
    isFullScreen: false,
    dontCache: [],
    uploadUrl: '/aichat/api/upload/unCheck',
    env: 'test',
    currentMenu: {}, //当前选中一级菜单
    isMobileApp: false, //是否是移动端
    canvasWidth: 1080,
    canvasHeight: 1920,
    updateCustomeList: false,
};

export default state;


// WEBPACK FOOTER //
// ./src/digitalHuman/store/state.js